export default "<div class=\"simple-skeleton\"></div>\r\n"